import { useSessionState } from 'hooks/use-session-state';
import { PaginationState, UsePaginationStateProps } from './use-pagination-state.types';
import { useCallback } from 'react';
import { PAGES } from 'common/enums';
import { IPagination } from 'hooks/use-table/use-table.props';

const usePaginationState = ({ page, defaultPaginationState = defaultPaging }: UsePaginationStateProps) => {
  const { state: paginationState, setSessionState: setPaginationState } = useSessionState<PaginationState>(
    PAGINATION_STATE_KEY,
    {}
  );

  const pagination = page ? paginationState[page] || defaultPaginationState : defaultPaginationState;

  const setPagination = useCallback(
    (pagination: IPagination) => {
      if (!page) {
        return;
      }
      setPaginationState({ ...paginationState, [page]: pagination });
    },
    [paginationState, setPaginationState, page]
  );

  const goToFirstPage = useCallback(
    (pageKey: PAGES | string) => {
      const prevPaginationState = paginationState[pageKey];
      if (prevPaginationState) {
        paginationState[pageKey] = { ...prevPaginationState, start: 1 };
        setPaginationState(paginationState);
      }
    },
    [paginationState, setPaginationState]
  );

  return { pagination, setPagination, goToFirstPage };
};

const PAGINATION_STATE_KEY = 'pagination-state';

const defaultPaging = {
  start: 1,
  number: 20
};

export default usePaginationState;
